export const IbanPrefix = 'DE';

export const DocumentTypes = {
  WARRANT: 'WARRANT',
  REJECTED_WARRANT: 'REJECTED_WARRANT',
  BALANCE_LIST: 'BALANCE_LIST',
  REJECTED_BALANCE_LIST: 'REJECTED_BALANCE_LIST',
  ADMONITION_BALANCE_LIST: 'ADMONITION_BALANCE_LIST',
  MISC: 'MISC',
};

export const DocumentStatus = {
  UNREADABLE_WITHOUT_IBAN: 'UNREADABLE_WITHOUT_IBAN',
  INCOMPLETE_WITH_IBAN: 'INCOMPLETE_WITH_IBAN',
  INCOMPLETE_WITHOUT_IBAN: 'INCOMPLETE_WITHOUT_IBAN',
  NEEDS_CLARIFICATION: 'NEEDS_CLARIFICATION',
  INCOMPLETE: 'INCOMPLETE',
  OTHER: 'OTHER',
  OK: 'OK',
};

export const InboxTabs = {
  OPEN: 'open',
  CLOSED: 'closed',
  REJECTED: 'rejected',
  NEED_CLARIFICATON: 'need_clarification',
};
